import type { PostContentChildDecoratorComponentType } from '@shared/dream-components';

import SignupAction from '~/components/SignupAction';

const SUBSCRIBER_BREAK_SIGNUP_ACTION_ID = 'subscriber-gate-signup-action';

export const ChildDecoratorComponent: PostContentChildDecoratorComponentType = ({ children, node, childNodeType }) => {
  switch (childNodeType) {
    case 'subscriberBreak':
      return (
        <SignupAction id={SUBSCRIBER_BREAK_SIGNUP_ACTION_ID}>
          {({ isLoading }) => children({ modifiedNode: node, isLoading })}
        </SignupAction>
      );
    default:
      return <>{children({ modifiedNode: node })}</>;
  }
};
